import { axiosSaveSite } from '../../api/admin/default';

window.isBanner = false;
(function ($) {
    RVwys.plugin['saveAsync'] = true;
    RVwys.save = {};
    RVwys.save.removeEle = {};
    RVwys.save.removeClass = {};
    RVwys.save.replaceEle = {};
    RVwys.save.replaceTxt = {};
    RVwys.save.replaceTxt = {};
    RVwys.save.replaceDisallow = {};

    $(document).bind('editorReady', function () {
        $('#saveall').click(function () {
            new saveAsync();
        });
    });

    class saveAsync {
        constructor() {
            this.head_content = parent
                .$('#frameBody')
                .contents()
                .find('#selected_header')
                .clone();
            this.header_edit;
            this.header_view;

            this.content = RVwys.save.getContent();
            this.content_edit;
            this.content_view;

            this.content_left = RVwys.save.getContentLeft();
            this.content_left_edit;
            this.content_left_view;

            this.content_right = RVwys.save.getContentRight();
            this.content_right_edit;
            this.content_right_view;

            this.footer = parent
                .$('#frameBody')
                .contents()
                .find('#selected_footer .mg')
                .clone();
            this.footer_edit;
            this.footer_view;

            this.init();
        }

        async init() {
            var isBefore = await this.before();
            var isSave = await this.save();
            var isAfter = await this.complete();
        }

        async before() {
            //			var res = false;
            //			no await

            //			await
            $(document).trigger('beforeSave');
            var isRemove = await this.removeData();
            var isrep = await this.replaceData();
            /*if(this.arrImg&& isRemove &&isrep ) {
				return res;

			}*/
        }

        async complete() {
            $(document).trigger('saveComplete');
            console.log('-- Saveasync complete --');
        }

        async afterError() {
            $(document).trigger('afterSaveError');
            console.log('-- Saveasync afterError --');
        }

        async afterSuccess() {
            $(document).trigger('afterSaveSuccess');
            console.log('-- Saveasync afterSuccess --');
        }

        async save() {
            var isEncode = await this.encodeData();
            var slug_id =
                $('#slug_id').length == 1
                    ? $('#slug_id').val()
                    : parent.$('#slug_id').val();
            var oThis = this;
            var saveAjax = await axiosSaveSite({
                savetype: 'saveall',
                isMasterHeader: $('#isMasterHeader').val(),
                isMasterFooter: $('#isMasterFooter').val(),
                isHomepage: $('#isHomepage').val(),
                isBanner: window.isBanner,
                slug_id: slug_id,
                global_post: this.glodbalPost(),
                // Header
                header_content_edit: this.header_edit,
                header_content_view: this.header_view,
                // Page / Post Content
                page_content_edit: this.content_edit,
                page_content_view: this.content_view,
                // Meta auto
                meta_title_auto: this.meta_title(),
                meta_des_auto: this.meta_des(),
                // Sidebar
                use_sidebar: parent.user_sidebar,
                isCustom_sidebar: parent.isCustom_sidebar,
                left_content_edit: this.content_left_edit,
                left_content_view: this.content_left_view,
                right_content_edit: this.content_right_edit,
                right_content_view: this.content_right_view,

                //Footer
                footer_content_edit: this.footer_edit,
                footer_content_view: this.footer_view,

                widget_global_settings: this.getGlobalwidget(),
            })
                .then(result => {
                    // if have error response all error : pnotice only one success
                    const err = $.map(result.data, function (el) {
                        return el.status;
                    }).indexOf('error');
                    if (~err) {
                        $.each(result.data, function (i, v) {
                            if (v.status == 'error') {
                                console.error(v.response_msg);

                                console.pop.error({
                                    text: 'Save Fail',
                                    delay: 3000,
                                });
                            }
                        });
                    } else {
                        console.pop.success({
                            text: 'Saved Success',
                            delay: 3000,
                        });
                    }

                    oThis.afterSuccess();
                })
                .catch(err => {
                    console.pop.error({
                        text: err.responseJSON.message,
                    });
                });

            return saveAjax;
        }

        async removeData() {
            var isEle = await this.removeElement();
            var isClass = await this.removeClass();

            return;
        }

        async replaceData() {
            await this.replaceElement();
            await this.replaceTEXT();
        }

        async removeElement() {
            var header = this.removeEleHeader();
            var content = this.removeEleContent();
            var left = this.removeEleContentLeft();
            var right = this.removeEleContentRight();
            var footer = this.removeEleContentFooter();

            await header;
            await content;
            await left;
            await right;
            await footer;
        }

        async removeClass() {
            var header = this.removeClassHeader();
            var content = this.removeClassContent();
            var left = this.removeClassContentLeft();
            var right = this.removeClassContentRight();
            var oDocument = this.removeClassDocument();

            await header;
            await content;
            await left;
            await right;
            await oDocument;
        }

        async replaceElement() {
            var header = this.replaceEleHeader();
            var content = this.replaceEleContent();
            var left = this.replaceEleContentLeft();
            var right = this.replaceEleContentRight();
            var footer = this.replaceEleFooter();

            await header;
            await content;
            await left;
            await right;
            await footer;
        }

        async replaceTEXT() {
            var header = this.replaceTxtHeader();
            var content = this.replaceTxtContent();
            var left = this.replaceTxtContentLeft();
            var right = this.replaceTxtContentRight();
            var footer = this.replaceTxtFooter();

            await header;
            await content;
            await left;
            await right;
            await footer;
        }
        //		encode
        async encodeData() {
            this.header_edit = RVwys.save.encodeHTMLentities(this.header_edit);
            this.header_view = RVwys.save.encodeHTMLentities(this.header_view);

            this.content_edit = RVwys.save.encodeHTMLentities(
                this.content_edit
            );

            this.content_view = RVwys.save.encodeHTMLentities(
                this.content_view
            );

            this.content_left_edit = RVwys.save.encodeHTMLentities(
                this.content_left_edit
            );
            this.content_left_view = RVwys.save.encodeHTMLentities(
                this.content_left_view
            );
            this.content_right_edit = RVwys.save.encodeHTMLentities(
                this.content_right_edit
            );
            this.content_right_view = RVwys.save.encodeHTMLentities(
                this.content_right_view
            );

            this.footer_edit = RVwys.save.encodeHTMLentities(this.footer_edit);
            this.footer_view = RVwys.save.encodeHTMLentities(this.footer_view);
        }

        //		removeEle
        async removeEleHeader() {
            this.header_edit = RVwys.save.removeEle.headerEditmode(
                this.head_content
            );
            var elm_view = this.head_content.clone();
            this.header_view = RVwys.save.removeEle.headerViewmode(elm_view);
        }

        async removeEleContent() {
            this.content_edit = await RVwys.save.removeEle.contentEditmode(
                this.content
            );

            var elm_view = this.content.clone();
            this.content_view = await RVwys.save.removeEle.contentViewmode(
                elm_view
            );
        }

        async removeEleContentLeft() {
            this.content_left_edit = RVwys.save.removeEle.contentEditmode(
                this.content_left
            );

            var elm_view = this.content_left.clone();
            this.content_left_view = RVwys.save.removeEle.contentViewmode(
                elm_view
            );
        }

        async removeEleContentRight() {
            this.content_right_edit = RVwys.save.removeEle.contentEditmode(
                this.content_right
            );

            var elm_view = this.content_right.clone();
            this.content_right_view = RVwys.save.removeEle.contentViewmode(
                elm_view
            );
        }

        async removeEleContentFooter() {
            this.footer_edit = RVwys.save.removeEle.contentFooter(this.footer);
            var elm_view = this.footer_edit.clone();
            this.footer_view = RVwys.save.removeEle.contentFooterView(elm_view);
        }

        //		removeClass
        async removeClassHeader() {
            this.header_edit = RVwys.save.removeClass.headerEditmode(
                this.header_edit
            );
            this.header_view = RVwys.save.removeClass.headerViewmode(
                this.header_view
            );
        }

        async removeClassContent() {
            this.content_edit = RVwys.save.removeClass.contentEditmode(
                this.content_edit
            );
            this.content_view = RVwys.save.removeClass.contentViewmode(
                this.content_view
            );
        }

        async removeClassContentLeft() {
            this.content_left_edit = RVwys.save.removeClass.contentEditmode(
                this.content_left_edit
            );
            this.content_left_view = RVwys.save.removeClass.contentViewmode(
                this.content_left_view
            );
        }

        async removeClassContentRight() {
            this.content_right_edit = RVwys.save.removeClass.contentEditmode(
                this.content_right_edit
            );
            this.content_right_view = RVwys.save.removeClass.contentViewmode(
                this.content_right_view
            );
        }
        async removeClassDocument() {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            fb.RVwys.removePreviewWidget();
            fb.$('.activeWidget').removeClass('activeWidget');
        }

        //	   replaceEle
        async replaceEleHeader() {
            this.header_edit = RVwys.save.replaceEle.headerEditmode(
                this.header_edit
            );
            this.header_view = RVwys.save.replaceEle.headerViewmode(
                this.header_view
            );
        }

        async replaceEleContent() {
            this.content_edit = RVwys.save.replaceEle.contentEditmode(
                this.content_edit
            );
            this.content_view = RVwys.save.replaceEle.contentViewmode(
                this.content_view
            );
        }

        async replaceEleContentLeft() {
            this.content_left_edit = RVwys.save.replaceEle.contentEditmode(
                this.content_left_edit
            );
            this.content_left_view = RVwys.save.replaceEle.contentViewmode(
                this.content_left_view
            );
        }

        async replaceEleContentRight() {
            this.content_right_edit = RVwys.save.replaceEle.contentEditmode(
                this.content_right_edit
            );
            this.content_right_view = RVwys.save.replaceEle.contentViewmode(
                this.content_right_view
            );
        }

        async replaceEleFooter() {
            this.footer_edit = RVwys.save.replaceEle.contentFooter(
                this.footer_edit
            );
            this.footer_view = RVwys.save.replaceEle.contentFooterView(
                this.footer_view
            );
        }

        //	   replaceTxt
        async replaceTxtHeader() {
            this.header_edit = RVwys.save.replaceTxt.headerEditmode(
                this.header_edit
            );
            this.header_view = RVwys.save.replaceTxt.headerViewmode(
                this.header_view
            );
        }

        async replaceTxtContent(elm) {
            this.content_edit = RVwys.save.replaceTxt.contentEditmode(
                this.content_edit
            );

            this.content_view = RVwys.save.replaceTxt.contentViewmode(
                this.content_view
            );
        }

        async replaceTxtContentLeft() {
            this.content_left_edit = RVwys.save.replaceTxt.contentEditmode(
                this.content_left_edit
            );
            this.content_left_view = RVwys.save.replaceTxt.contentViewmode(
                this.content_left_view
            );
        }

        async replaceTxtContentRight() {
            this.content_right_edit = RVwys.save.replaceTxt.contentEditmode(
                this.content_right_edit
            );
            this.content_right_view = RVwys.save.replaceTxt.contentViewmode(
                this.content_right_view
            );
        }

        async replaceTxtFooter() {
            this.footer_edit = RVwys.save.replaceTxt.contentFooter(
                this.footer_edit
            );
            this.footer_view = RVwys.save.replaceTxt.contentFooterView(
                this.footer_view
            );
        }

        getGlobalwidget() {
            var datasetting = {};
            //var widgetCls = [ 'imgrv_register_form', 'imgrvlogin_user_form' ,'imgrvlogin_admin_form' ];
            var widgetCls = ['imgregister', 'imglogin-user', 'imglogin-admin'];

            var isglobalWidget = false;

            if (parent.elmSetWidget) {
                $.each(widgetCls, function (key, value) {
                    if (parent.elmSetWidget.hasClass(value)) {
                        isglobalWidget = true;
                    }
                });

                if (isglobalWidget) {
                    var fb = parent.$('#frameBody').get(0).contentWindow;
                    var id = parent.elmSetWidget.get(0).id;

                    fb.$('#' + id).each(function () {
                        $.each(this.attributes, function () {
                            if (this.specified) {
                                if (this.name.match(/setting_/g)) {
                                    datasetting[this.name] = this.value;
                                }
                            }
                        });
                    });
                }
            }

            return datasetting;
        }

        meta_title() {
            var tagHead = parent
                .$('#frameBody')
                .contents()
                .find('.bodyTemplate')
                .find('h1, h2, h3, h4, h5, h6')
                .first()
                .text();

            return tagHead;
        }

        meta_des() {
            return parent
                .$('#frameBody')
                .contents()
                .find('#selected_body .mg:not(.mgwidget) p:not(img)')
                .first()
                .text();
        }

        glodbalPost() {
            var global_post = [];
            if ($('#isType').val() == 'Post') {
                global_post = RVwys.save.getDataPostGlobal();
            }

            return global_post;
        }

        //	   FnClass ใหม่ ให้ตั้งชื่อขึ้นต้นตาม Process คือ set_ หรือ get_
    }

    RVwys.save.getContent = function () {
        var content_center = $('<div>');
        /** content **/
        var page_content = '';

        if ($('#isType').val() == 'Post') {
            page_content =
                $('#editable_area_content .mg:not(.mgwidget)').length > 0
                    ? /* ? $('#editable_area_content .mg:not(.mgwidget)').clone()
				 : $('#frameBody').contents().find('#editable_area_content .mg:not(.mgwidget)').clone(); */
                      $('.blog_end_global_header_edit')
                          .nextUntil('.blog_start_global_footer_edit', '.mg')
                          .clone()
                    : $('#frameBody')
                          .contents()
                          .find('.blog_end_global_header_edit')
                          .nextUntil('.blog_start_global_footer_edit', '.mg')
                          .clone();
        } else {
            page_content =
                $('#editable_area_content .mg').length > 0
                    ? $('#editable_area_content .mg').clone()
                    : $('#frameBody')
                          .contents()
                          .find('#editable_area_content .mg')
                          .clone();
        }

        page_content.each(function () {
            content_center.append($(this));
        });

        return content_center;
    };

    RVwys.save.getContentSide = function (cls) {
        var content = $('<div>');
        var checkSb = $('#frameBody').contents().find(cls);

        var sidebar = $('#frameBody').contents().find(`${cls} .mg`).clone();

        if (checkSb.is(':hidden')) {
            content = $('<div class="noSidebar">');
            sidebar.each(function () {
                content.append($(this));
            });
        } else {
            sidebar.each(function () {
                content.append($(this));
            });
        }

        return content;
    };

    RVwys.save.getContentLeft = function () {
        return RVwys.save.getContentSide('.sidebar-left');
    };

    RVwys.save.getContentRight = function () {
        return RVwys.save.getContentSide('.sidebar-right');
    };

    RVwys.save.encodeHTMLentities = function (content) {
        // console.log('-- before '+content.length+' byte --');
        var row = $('<div />');
        content = row.text(content).html();
        // console.log('-- after '+content.length+' byte --');
        return content;
    };

    RVwys.save.replaceDisallow = function (content) {
        const disallowData = parent.wex.disallow_keyword;

        for (const disallowKey in disallowData) {
            if (disallowData.hasOwnProperty(disallowKey)) {
                const disallow = disallowData[disallowKey];
                var reg_disallow = new RegExp(disallowKey + '=', 'gi');
                content.html(
                    content
                        .html()
                        .replace(reg_disallow, '[[' + disallow + ']]=')
                );
            }
        }

        return content;
    };

    /** Header removeEle **/
    RVwys.save.removeEle.headerEditmode = function (content) {
        if (!content.get(0)) {
            console.pop.error({
                text: 'No have Object ID selected_header',
                delay: 2000,
            });
            return false;
        }

        content.find('.navMenu-blockMainSetting').remove();
        content.find('.blockTools').remove();
        content.find('.SlideProperty').remove();

        //		Slideshow
        content.find('.uk-cover-background').remove();
        content.find('.uk-slideshow-ghost').remove();

        //		Custom Banner
        content.find('#CustomBannerFigure>.uk-container').unwrap();

        content.find('#CustomBannerFig').remove();
        content.find('.overlayCustomBanner').remove();
        content.find('#CustomBannerFigure').remove();
        content.find('#editCustombanner').remove();
        content.find('.layCustomBanner').remove();
        content.find('.closePreviewWidget').remove();
        return content;
    };

    RVwys.save.removeEle.headerViewmode = function (content) {
        content.find('.navMenu-blockMainSetting').remove();
        content.find('.blockTools').remove();
        content.find('.SlideProperty').remove();

        //		Slideshow
        content.find('.uk-cover-background').remove();
        content.find('.uk-slideshow-ghost').remove();

        //		Custom Banner
        content.find('#CustomBannerFigure>.uk-container').unwrap();

        content.find('#CustomBannerFig').remove();
        content.find('.overlayCustomBanner').remove();
        content.find('#CustomBannerFigure').remove();
        content.find('#editCustombanner').remove();
        content.find('.layCustomBanner').remove();
        content.find('.closePreviewWidget').remove();

        return content;
    };
    /** Header removeClass **/
    RVwys.save.removeClass.headerEditmode = function (content) {
        var duration = content.find('#rvs-uk-slide').data('duration');
        var mgSlideTime = duration == 'undefined' ? '5' : duration;
        var timeSlide = mgSlideTime == '' ? '500ms' : mgSlideTime * 1000 + 'ms';

        content.find('.mgActive').removeClass('mgActive');
        content.find('#rvs-uk-slide .uk-slideshow li').removeAttr('style');

        content.find('#rvs-uk-slide .uk-slideshow li').css({
            'animation-duration': timeSlide,
        });
        content
            .find('.uk-dotnav [data-uk-slideshow-item]')
            .removeClass('uk-active');
        return content;
    };

    RVwys.save.removeClass.headerViewmode = function (content) {
        var duration = content.find('#rvs-uk-slide').data('duration');
        var mgSlideTime = duration == 'undefined' ? '5' : duration;
        var timeSlide = mgSlideTime == '' ? '500ms' : mgSlideTime * 1000 + 'ms';

        var slideshow = content.find('#rvs-uk-slide').data('uk-slideshow');
        var auto = slideshow == '' ? '{autoplay:true}' : slideshow;

        content.find('.mgActive').removeClass('mgActive');
        content.find('#rvs-uk-slide').attr({
            'data-uk-slideshow': auto,
        });

        content.find('#rvs-uk-slide .uk-slideshow li').removeAttr('style');
        content.find('#rvs-uk-slide .uk-slideshow li').css({
            'animation-duration': timeSlide,
        });
        content
            .find('.uk-dotnav [data-uk-slideshow-item]')
            .removeClass('uk-active');

        content.find('.RVWYSIWYGAREA').removeAttr('data-ph');
        content.find('.RVWYSIWYGAREA').removeAttr('id');
        content
            .find('.RVWYSIWYGAREA')
            .removeClass('RVWYSIWYGAREA editorCurrent areaCustom');
        content.find('[contenteditable]').removeAttr('contenteditable');
        return content;
    };

    /** Header replaceEle **/
    RVwys.save.replaceEle.headerEditmode = function (content) {
        content.find('logo').html('[[LOGO]]');
        content.find('logo_mobile').html('[[LOGO_MOBILE]]');
        content.find('#selected_topmenu top_nav').html('[[TOP_NAV]]');
        content.find('#selected_topmenu tel').html('[[TEL]]');
        content.find('#selected_navigator .js-right-nav').html('[[RIGHT_NAV]]');
        content.find('#selected_navigator .js-left-nav').html('[[LEFT_NAV]]');

        content.find('nav.uk-navbar').css('width', '100%');

        if (content.find('.uk-navbar').parent().is('.uk-sticky-placeholder')) {
            content.find('.uk-navbar').unwrap();
        }

        return content;
    };

    RVwys.save.replaceEle.headerViewmode = function (content) {
        content.find('logo').html('[[LOGO]]');
        content.find('logo_mobile').html('[[LOGO_MOBILE]]');
        content.find('#selected_topmenu top_nav').html('[[TOP_NAV]]');
        content.find('#selected_topmenu tel').html('[[TEL]]');
        content.find('#selected_navigator .js-right-nav').html('[[RIGHT_NAV]]');
        content.find('#selected_navigator .js-left-nav').html('[[LEFT_NAV]]');

        content.find('nav.uk-navbar').css('width', '100%');

        if (content.find('.uk-navbar').parent().is('.uk-sticky-placeholder')) {
            content.find('.uk-navbar').unwrap();
        }

        content
            .find('img.lazy')
            .each(function () {
                var oldattr = $(this).attr('src');
                $(this)
                    .attr({
                        'data-src': oldattr,
                    })
                    .removeAttr('src');
            })
            .end()
            .find('div.lazy')
            .each(function () {
                var style = $(this)
                    .css('background-image')
                    .match(/url\(\"?(.*?)\"?\)+?/);
                var imgurl = style ? style[1] : '';

                $(this).attr('data-src', imgurl);
            });

        return content;
    };

    /** Header replaceTxt **/
    RVwys.save.replaceTxt.headerEditmode = function (content) {
        var cdnURL = new RegExp(parent.wex.cdn.cdnURL, 'img');
        var regex = new RegExp(parent.wex.url.baseUrl, 'img');

        content = RVwys.save.replaceDisallow(content);
        content = content
            .html()
            .replace(cdnURL, '[[CDN_URL]]')
            .replace(regex, '[[URL]]')
            .replace(/\<\!--\?/gim, '#RVWYSIWYGSTARTPHP#')
            .replace(/\?--\>/gim, '#RVWYSIWYGENDPHP#')
            .replace(/url\(&quot;?(.*?)&quot;?\)+?/gm, function (url) {
                return url.replace(/&quot;/gm, '');
            });
        return content;
    };

    RVwys.save.replaceTxt.headerViewmode = function (content) {
        var cdnURL = new RegExp(parent.wex.cdn.cdnURL, 'img');
        var regex = new RegExp(parent.wex.url.baseUrl, 'img');

        content = RVwys.save.replaceDisallow(content);
        content = content.unplaceHolders('origenal');
        content = content
            .html()
            .replace(cdnURL, '[[CDN_URL]]')
            .replace(regex, '[[URL]]')
            .replace('cmdhref', 'href')
            .replace('data-href', 'href')
            .replace(/\<\!--\?/gim, '#RVWYSIWYGSTARTPHP#')
            .replace(/\?--\>/gim, '#RVWYSIWYGENDPHP#')
            .replace(/rv-data-uk-scrollspy/gim, 'data-uk-scrollspy')
            .replace(/url\(&quot;?(.*?)&quot;?\)+?/gm, function (url) {
                return url.replace(/&quot;/gm, '');
            });

        return content;
    };

    /** Content removeEle **/
    RVwys.save.removeEle.contentEditmode = function (content) {
        if (!content.get(0)) {
            console.pop.error({
                text: 'No have Object Class design-block',
                delay: 2000,
            });
            return false;
        }

        content.find('.navMenu-blockMainSetting').remove();
        content.find('.blockTools').remove();
        content.find('.containerWidget').remove();
        content.find('.layoutResize').remove();
        content.find('.wgetAll').remove();
        content.find('.addBlockLink').remove();
        content.find('.closePreviewWidget').remove();

        if ($('#frameBody').get(0)) {
            $('#frameBody')
                .get(0)
                .contentWindow.$('.customFromAPI') // tools ตัวนี้ไม่ได้อยู่ใน content แต่อยู่ใน frameBody
                .remove();
        }

        return content;
    };

    RVwys.save.removeEle.contentViewmode = function (content) {
        if (!content.get(0)) {
            console.pop.error({
                text: 'No have Object Class design-block',
                delay: 2000,
            });
            return false;
        }

        content.find('.navMenu-blockMainSetting').remove();
        content.find('.blockTools').remove();
        content.find('.containerWidget').remove();
        content.find('.layoutResize').remove();
        content.find('.wgetAll').remove();
        content.find('.addBlockLink').remove();
        content.find('.closePreviewWidget').remove();

        content.find('.dropHere').remove();
        content.find('.jsgooglemap.uk-overlay-panel').remove();

        return content;
    };

    /** Content removeClass **/
    RVwys.save.removeClass.contentEditmode = function (content) {
        content.find('.mgActive').removeClass('mgActive');
        content.find('.ui-selected').removeClass('ui-selected');
        content
            .find('.RVWYSIWYGAREA')
            .removeAttr('contenteditable')
            .removeClass('editorCurrent');
        content.find('.ui-resizable-handle').removeClass('ui-resizable-handle');
        content.find('.ui-resizable-e').removeClass('ui-resizable-e');
        content.find('.ui-resizable-s').removeClass('ui-resizable-s');
        content.find('.ui-resizable').removeClass('ui-resizable');
        content.find('.ui-selectee').removeClass('ui-selectee');

        return content;
    };

    RVwys.save.removeClass.contentViewmode = function (content) {
        //remove content on display:none
        if (content.hasClass('noSidebar')) content.find('.mg').remove();

        content.find('.mgActive').removeClass('mgActive');
        content.find('.ui-selected').removeClass('ui-selected');
        content.find('.ui-resizable-handle').removeClass('ui-resizable-handle');
        content.find('.ui-resizable-e').removeClass('ui-resizable-e');
        content.find('.ui-resizable-s').removeClass('ui-resizable-s');
        content.find('.ui-resizable').removeClass('ui-resizable');
        content.find('.ui-selectee').removeClass('ui-selectee');

        content.find('[contenteditable]').removeAttr('contenteditable');
        content.find('div[defaultvalue]').removeAttr('defaultvalue');
        content.find('.layoutCurrent').removeClass('layoutCurrent');
        content
            .find('.RVWYSIWYGAREA')
            .removeAttr('contenteditable')
            .removeClass('editorCurrent');
        content.find('.RVWYSIWYGAREA').removeAttr('data-ph');
        content.find('.RVWYSIWYGAREA').removeAttr('id');
        content.find('.RVWYSIWYGAREA').removeClass(RVwys.effectClass);
        content
            .find('.RVWYSIWYGAREA')
            .removeClass('RVWYSIWYGAREA editorCurrent areaCustom');

        return content;
    };

    /** Content replaceEle **/

    RVwys.save.replaceEle.contentEditmode = function (content) {
        content = RVwys.save.replaceNav(content);
        return content;
    };

    RVwys.save.replaceEle.contentViewmode = function (content) {
        content.find('img.lazy').each(function () {
            var oldattr = $(this).attr('src');
            $(this)
                .attr({
                    'data-src': oldattr,
                })
                .removeAttr('src');
        });
        content
            .find('div.lazy')
            .each(function () {
                var style = $(this)
                    .css('background-image')
                    .match(/url\(\"?(.*?)\"?\)+?/);
                var imgurl = style ? style[1] : '';

                $(this).attr('data-src', imgurl);
            })
            .css('background-image', '');
        content = RVwys.save.replaceNav(content);

        return content;
    };

    /** Content replaceTxt **/
    RVwys.save.replaceTxt.contentEditmode = function (content) {
        var cdnURL = new RegExp(parent.wex.cdn.cdnURL, 'img');
        var regex = new RegExp(parent.wex.url.baseUrl, 'img');
        content = RVwys.save.replaceDisallow(content);

        content = content
            .html()
            .replace(cdnURL, '[[CDN_URL]]')
            .replace(regex, '[[URL]]')
            .replace(/\<\!--\?/gim, '#RVWYSIWYGSTARTPHP#')
            .replace(/\?--\>/gim, '#RVWYSIWYGENDPHP#')
            .replace(/url\(&quot;?(.*?)&quot;?\)+?/gm, function (url) {
                return url.replace(/&quot;/gm, '');
            });

        return content;
    };

    RVwys.save.replaceTxt.contentViewmode = function (content) {
        var cdnURL = new RegExp(parent.wex.cdn.cdnURL, 'img');
        var regex = new RegExp(parent.wex.url.baseUrl, 'img');

        content = RVwys.save.replaceDisallow(content);
        content = content.unplaceHolders('origenal');
        content = content
            .html()
            .replace(cdnURL, '[[CDN_URL]]')
            .replace(regex, '[[URL]]')
            .replace(/\<\!--\?/gim, '#RVWYSIWYGSTARTPHP#')
            .replace(/\?--\>/gim, '#RVWYSIWYGENDPHP#')
            .replace(/rv-data-uk-scrollspy/gim, 'data-uk-scrollspy')
            .replace(/url\(&quot;?(.*?)&quot;?\)+?/gm, function (url) {
                return url.replace(/&quot;/gm, '');
            });

        return content;
    };

    /** Footer removeEle **/
    RVwys.save.removeEle.contentFooter = function (content) {
        content.find('.containerWidget').remove();
        content.find('.closePreviewWidget').remove();

        return content;
    };

    RVwys.save.removeEle.contentFooterView = function (content) {
        content.find('.rv-ribbon').remove();
        content.find('.closePreviewWidget').remove();

        return content;
    };

    /** Footer replaceEle **/
    RVwys.save.replaceEle.contentFooter = function (content) {
        content.find('#titleInformation').html('[[TITLEINFO]]');
        content.find('#contentInformation').html('[[CONTENTINFO]]');
        content.find('#titleContact').html('[[TITLECONTACT]]');
        content.find('#addressContactFooter').html('[[ADDRESS]]');
        content.find('tel').html('[[TEL]]');
        content.find('#emailContactFooter').html('[[EMAIL]]');

        content.find('powered').html('[[POWERED]]');
        content.find('copyright').html('[[COPYRIGHT]]');

        content.find('#sitemapFooter').html('[[SITEMAP]][[LOGIN]]');

        return content;
    };

    RVwys.save.replaceEle.contentFooterView = function (content) {
        content = RVwys.save.replaceEle.contentFooter(content);
        return content;
    };

    /** Footer replaceTxt **/
    RVwys.save.replaceTxt.contentFooter = function (content) {
        content = RVwys.save.replaceDisallow(content);
        return content.html();
    };

    RVwys.save.replaceTxt.contentFooterView = function (content) {
        content = RVwys.save.replaceDisallow(content);
        content = content.html().replace('cmdherf', 'herf');
        return content;
    };

    RVwys.save.getDataPostGlobal = function () {
        var slug_id =
            $('#slug_id').length == 1
                ? $('#slug_id').val()
                : parent.$('#slug_id').val();
        var arr_blog_footer = $('<div/>');
        var arr_blog_header = $('<div/>');

        var blog_header = $('#frameBody')
            .contents()
            .find('.blog_start_global_header_edit')
            .nextUntil('.blog_end_global_header_edit', '.mg')
            .clone();
        var blog_footer = $('#frameBody')
            .contents()
            .find('.blog_start_global_footer_edit')
            .nextUntil('.blog_end_global_footer_edit', '.mg')
            .clone();

        var arr_cdn_header = blog_header.find(
            'img[src*="' + wex.cdn.cdnURL + '"]'
        );
        var array_src_header = [];

        arr_cdn_header.each(function () {
            array_src_header.push($(this).get(0).attributes.src.nodeValue);
        });

        var arr_cdn_footer = blog_footer.find(
            'img[src*="' + wex.cdn.cdnURL + '"]'
        );
        var array_src_footer = [];

        arr_cdn_footer.each(function () {
            array_src_footer.push($(this).get(0).attributes.src.nodeValue);
        });

        blog_header.each(function () {
            arr_blog_header.append($(this));
        });

        blog_footer.each(function () {
            arr_blog_footer.append($(this));
        });

        //	.mg blog global Header
        arr_blog_header.find('.mgActive').removeClass('mgActive');
        arr_blog_header.find('.navMenu-blockMainSetting').remove();
        arr_blog_header.find('.blockTools').remove();
        arr_blog_header.find('.containerWidget').remove();
        arr_blog_header = RVwys.save.replaceDisallow(arr_blog_header);
        //	.mg blog global footer
        arr_blog_footer.find('.mgActive').removeClass('mgActive');
        arr_blog_footer.find('.navMenu-blockMainSetting').remove();
        arr_blog_footer.find('.blockTools').remove();
        arr_blog_footer.find('.containerWidget').remove();
        arr_blog_footer = RVwys.save.replaceDisallow(arr_blog_footer);

        var header_content_edit =
            '<div class="blog_start_global_header_edit"></div>' +
            arr_blog_header.html() +
            '<div class="blog_end_global_header_edit"></div>';
        var header_content_view = RVwys.clearUiView($(arr_blog_header).clone());

        var footer_content_edit =
            '<div class="blog_start_global_footer_edit"></div>' +
            arr_blog_footer.html() +
            '<div class="blog_end_global_footer_edit"></div>';
        var footer_content_view = RVwys.clearUiView($(arr_blog_footer).clone());

        var page_content = $('#frameBody')
            .contents()
            .find('.blog_end_global_header_edit')
            .nextUntil('.blog_start_global_footer_edit', '.mg')
            .clone();
        var arr_content = $('<div>');
        page_content.each(function () {
            arr_content.append($(this));
        });

        var first_img = arr_content
            .find('.mg:not(.mgwidget) img')
            .first()
            .attr('src');

        var dataGlobalPost = {
            slug_id: slug_id,
            first_img: first_img,
            header_content_edit: header_content_edit,
            header_content_view: header_content_view,
            footer_content_edit: footer_content_edit,
            footer_content_view: footer_content_view,
            cdn_header: array_src_header,
            cdn_footer: array_src_footer,
        };

        return dataGlobalPost;
    };

    RVwys.save.replaceNav = function (content) {
        if (content.find('.uk-navbar').parent().is('.uk-sticky-placeholder')) {
            content.find('.uk-navbar').unwrap();
            RVwys.save.replaceNav(content);
        }

        return content;
    };

    $(document).bind('designReady', function (e) {
        //disable/uninstall widget
        $('.bodyTemplate')
            .find('[data-appname],[widget]')
            .each(function () {
                var appName =
                    $(this).attr('data-appname') || $(this).attr('widget');
                var isWidget = false;
                console.log('editmode appName -->' + appName);

                //skip widget="#socialbutton"
                if (appName != '#socialbutton') {
                    //disable app
                    if (parent.wex.appconfig && parent.wex.appconfig[appName]) {
                        if (
                            parent.wex.appconfig[appName]['deleted_at'] &&
                            parent.wex.appconfig[appName]['deleted_at'] != ''
                        ) {
                            $(this).toggle(false);
                        }
                    } else {
                        //uninstall app
                        console.log('remove case widget ->' + $(this).get(0));
                        $(this).remove();
                    }
                }
            });

        $('.bodyTemplate')
            .find('[widgetname="social_widget"],[widget-name="social"]')
            .each(function () {
                if ($(this).attr('data-appname') == undefined) {
                    $(this).attr('data-appname', 'rvsitebuilder/core');
                }
            });
    });

    RVwys.designViewAddEvent('mouseup', function (e) {});

    RVwys.designViewAddEvent('keyup', function (e) {});



	RVwys.clearUiView = function(content_view){

        //	replace url
            var regex = new RegExp(parent.wex.url.baseUrl, 'img');

            content_view.find('.navMenu-blockMainSetting').remove();
            content_view.find('.blockTools').remove();
            content_view.find('.dropHere').remove();
            content_view.find('.jsgooglemap.uk-overlay-panel').remove();

            content_view.find('[contenteditable]').removeAttr('contenteditable');
            content_view.find('.mgActive').removeClass('mgActive');
            content_view.find("div[defaultvalue]").removeAttr('defaultvalue');
            content_view.find('.layoutCurrent').removeClass('layoutCurrent');
            content_view.find('.RVWYSIWYGAREA').removeAttr('data-ph');
            content_view.find('.RVWYSIWYGAREA').removeAttr('id');
            content_view.find('.RVWYSIWYGAREA').removeClass(RVwys.effectClass);
            content_view.find('.RVWYSIWYGAREA').removeClass('RVWYSIWYGAREA editorCurrent areaCustom');

            var ReplaceURL = content_view.html()
            .replace(regex,'[[URL]]')
            .replace(/\<\!--\?/img,'#RVWYSIWYGSTARTPHP#')
            .replace(/\?--\>/img,'#RVWYSIWYGENDPHP#')
            .replace(/rv-data-uk-scrollspy/img,'data-uk-scrollspy');

            return ReplaceURL;
        }

})(jQuery);
